// extracted by mini-css-extract-plugin
export default {"brandPromo":"_H-z","carousel":"aI-z"};